import React from 'react';
import ErrorView from 'components/generic/ErrorView';

export default function Unauthorised() {
  return <ErrorView preset="UnauthorizedPage" />;
}
